/** The capture editor's heading, shared with React and isolated DOM hosts. */
export const CAPTURE_HEADING_CLASS = 'oq-capture-heading';
export function createCaptureHeading(doc, title) {
    const heading = doc.createElement('span');
    heading.className = CAPTURE_HEADING_CLASS;
    heading.setAttribute('data-capture-heading', '');
    heading.setAttribute('role', 'heading');
    heading.setAttribute('aria-level', '3');
    heading.textContent = title;
    return heading;
}
//# sourceMappingURL=captureHeadingDom.js.map